export default "__VITE_ASSET__9b40cd0c__"